import { useState, type FormEvent } from 'react';
import { partnerLogin } from '@services/partnerService';
import { usePartnerAuth } from '../PartnerAuthContext';
import { Button, Card, ErrorNote, Field, PageShell, Title } from '../ui';

const PartnerLogin = () => {
  const { login } = usePartnerAuth();
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const session = await partnerLogin(usuario.trim(), password);
      login(session.token, session.partner);
    } catch (err: unknown) {
      const status = (err as { response?: { status?: number } })?.response?.status;
      if (status === 403) setError('Tu cuenta no tiene el modulo de onboarding de partners.');
      else if (status === 401) setError('Usuario o contrasena invalidos.');
      else setError('No se pudo iniciar sesion. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageShell narrow>
      <Card>
        <Title sub="Inicia sesion con tu cuenta de staff para pre-registrar comercios.">Portal de Partners</Title>
        <form onSubmit={onSubmit}>
          <Field label="Usuario" value={usuario} onChange={setUsuario} autoComplete="username" required />
          <Field
            label="Contrasena"
            type="password"
            value={password}
            onChange={setPassword}
            autoComplete="current-password"
            required
          />
          {error && <ErrorNote>{error}</ErrorNote>}
          <Button type="submit" fullWidth disabled={loading} style={{ marginTop: 18 }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>
      </Card>
    </PageShell>
  );
};

export default PartnerLogin;
